import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Enums } from '../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: false,
})
export class ConfirmModalComponent implements OnInit {
  data: any;
  successActionLoading = false;
  errorMessageCode: number | null;
  errorMessage: string | null;
  successCallbackAction;
  title;
  description;
  successButtonName;
  abortButtonName;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  successAction() {
    this.errorMessage = null;
    this.successActionLoading = true;

    this.successCallbackAction(this.data).subscribe(
      (response) => {
        this.activeModal.close(true);
        this.successActionLoading = false;
      },
      (error) => {
        if (this.errorMessageCode) {
          this.errorMessage = Enums.errorCodes[this.errorMessageCode];
        }

        this.successActionLoading = false;
      }
    );
  }
}
